<div
  class="jump-to__container"
  #jumpTo
  [ngClass]="{
    'border-0': borders === false,
    'jump-to__container--mobile-wrap': mobileWrap
  }"
>
  <div class="jump-to__title text-center text-dark fw-bold pb-3">Jump to:</div>

  <div
    class="jump-to__buttons d-flex gap-3 justify-content-center align-items-center"
    [class.jump-to__buttons--mobile-wrap]="mobileWrap"
  >
  @for (button of jumpToRenderData; track button.buttonFragment; let idx = $index) {
    <a
      (click)="scrollTo(button.buttonFragment)"
      class="jump-to__button text-black text-decoration-none position-relative"
      [class.active]="activeSection === button.buttonFragment"
      [class.jump-to__button--mobile-wrap]="mobileWrap"
    >
      {{ button.buttonLabel }}
    </a>
    @if (mobileWrap && wrapIndex !== null && idx === wrapIndex) {
      <div class="w-100 d-lg-none"></div>
    }
  }
  </div>
</div>
